/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {PostCategory} from '../../core/_models'
import {useNavigate} from 'react-router-dom'
import _ from 'lodash'
type Props = {
  postCategory: PostCategory
}

const InfoCell: FC<Props> = ({postCategory}) => {
  const navigate = useNavigate()
  const viewAllBusinessHandler = () => {
    navigate(`/community-corner/${postCategory.id}/${postCategory.slug}`)
  }
  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>
        <a
          onClick={viewAllBusinessHandler}
          className='text-gray-800 text-hover-primary mb-1 pointer'
        >
          {postCategory?.name}
        </a>
      </div>
    </div>
  )
}

export {InfoCell}
